import translations from '@/components/translations/translations/storage';
import dictionary from '@/components/translations/dictionary/storage';
import tasks from '@/components/translations/tasks/storage';

export default {
    namespaced: true,
    modules: {
        translations,
        dictionary,
        tasks
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}